(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('HistoriesComponentController', HistoriesComponentController);

    HistoriesComponentController.$inject = ['$scope'];

    function HistoriesComponentController($scope) {
        var vm = this;

        vm.init = init();

        function init() {
            console.log('========= HISTORIES =========');
        }
    }
})();
